export default __webpack_public_path__ + "static/media/页面走失.53237402.png";